export const LogoMark = ({ className = "h-10 w-10", onDark = false }) => {
  const img = (
    <img src="/logo-icon.png" alt="" aria-hidden="true" className={className} />
  );
  return onDark ? (
    <span className="bg-[#F9F8F5] p-1 inline-flex">{img}</span>
  ) : (
    img
  );
};

export const Logo = ({ dark = false, large = false }) => (
  <div className="flex items-center gap-3" data-testid="brand-logo">
    <LogoMark onDark={dark} className={large ? "h-12 w-12 sm:h-14 sm:w-14" : "h-10 w-10"} />
    <div className="leading-none">
      <span
        className={`block font-display font-extrabold tracking-tight ${large ? "text-xl sm:text-2xl" : "text-lg"} whitespace-nowrap ${
          dark ? "text-white" : "text-navy"
        }`}
      >
        Solid Home Services
      </span>
      <span
        className={`block font-mono ${large ? "text-[10px] sm:text-[11px]" : "text-[10px]"} uppercase tracking-[0.3em] mt-1 ${
          dark ? "text-white/60" : "text-muted-foreground"
        }`}
      >
        Repairs & Installs
      </span>
    </div>
  </div>
);
